// api/auth/index.ts
import { keycloak } from '../../main'
import { notifyAnalytics } from '../analytics/notifyAnalytics'

// returns current Keycloak token (or null)
export function getAuthToken(): string | null {
  return keycloak?.token ?? null
}

// fire-and-forget logout
export async function logout() {
  try {
    await keycloak.logout({ redirectUri: window.location.origin })
  } catch (error) {
    notifyAnalytics({ type: 'log_error', data: error })
  }
}
